const ExportExcel = {
  install(Vue) {

    Vue.prototype.$exportToExcel = function (filename = '', condition = '') {

      var downloadLink;
      var tableHTML = '';
      var dataType = 'data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF';
      if (condition != '') {
        var tableSelect = document.getElementById(condition);
      }else{
        var tableSelect = document.getElementsByClassName('el-table');
      }
      for(let i = 0; tableSelect.length > i; i++) {
        let content = tableSelect[i].outerHTML.replace(/ /g, '%20').replace(/R\$/gi, '')
        tableHTML  += tableSelect[i].outerHTML.match(/R\$ \d.*/) ? parseFloat(content) : content
      }

      filename = filename ? filename + '.xls' : 'Relatorio_excel.xls';
      downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(['\ufeff', tableHTML], {
          type: dataType
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {

        downloadLink.href = dataType + tableHTML;
        downloadLink.download = filename;
        downloadLink.click();
      }
    }
  }
};

export default ExportExcel;
